import { CLOSE_MODAL, OPEN_MODAL } from './InviteFriends.actions';

export function reducer(state, action) {
  switch (action.type) {
    case CLOSE_MODAL: {
      return { ...state, isModalOpen: false };
    }
    case OPEN_MODAL: {
      return { ...state, isModalOpen: true };
    }
    default: {
      throw new Error(`${action.type} - not recognized`);
    }
  }
}

export default { reducer };
